import React, { useState } from 'react';
import {Link} from 'react-router-dom'
import line from '../assets/Line.png'
import initial from '../assets/initial.png'
import alarm from '../assets/alarm.png'
import "../pages/GoXDashboard/GoXDashboard.css"
import searchIcon from "../assets/searchIcon.png"
import add from '../assets/add.png'
import text from '../assets/text.png'
import all from '../assets/all.png'
import active from '../assets/active.png'
import inactive from '../assets/inactive.png'
import pending from '../assets/pending.png'
import Line from '../assets/Line.png'
import menu from '../assets/menu.png'
import {CiSearch} from 'react-icons/ci';

import './EmployeeFolder/EmployeeFolder.css';
import Table from './Table';
import Employeeconnect from '../pages/Invite/Employeeconnect';
import Invitesent from '../pages/Invite/Invitesent';
import Sendinvite from '../pages/Invite/Sendinvite';
import { signin } from '../action/user';
import Table2 from './SalaryTable';
import AttendanceTable from './AttendanceTable';



import {RiArrowRightSLine, RiArrowLeftSLine} from 'react-icons/ri'

function Attendance() {

  const [showDiv, setShowDiv] = useState(false);
  const [tab, setTab] = useState('')
  const [showOption, setShowOption] = useState(false);
  const [mode, setMode] = useState('')
  const [option, setOption] = useState('option1')
  const isEmpty = true;
  const [filterOption, setFilterOption] = useState(''); // Add this state for the filter

   // Function to handle the filter option change
   const handleFilterChange = (e) => {
    setFilterOption(e.target.value);
  };




  const toggleDiv = () => {
    setShowDiv(!showDiv);
  };
  
  return (
       <>
        <div className="icon " onClick={toggleDiv}>
          <img src={menu} alt="" />
        </div>
        {showDiv && (
        <div className=" your-div1">
            <div className='employ mt-5 d-flex justify-content-between'>
        <div className='d-flex '>
            <div className='emp'><h1><bold>Attendance</bold></h1></div>
            
       </div>

        <div className='d-flex ini '>
          <div className='mx-2'><img src={alarm} alt="" /></div>
          <div className='mx-2'><img src={line} alt="" /></div>
          <div><img src={initial} alt="" /></div>
        </div>
  </div>

  <div className='d-flex mx-3 mt-2 activities'>

    <div className='allemploy d-flex m-3'>
      <div><img src={all} alt="" /></div>
      <div className='mt-2 mx-2'>
        <h6>All employees</h6>
        <p><strong>144</strong></p>
      </div>
      <div className='mx-3'><img src={Line} alt="" /></div>
    </div>
    <div className='activeemploy d-flex m-3'>
      <div><img src={active} alt="" /></div>
      <div className='mt-2 mx-2'>
        <h6>Today</h6>
      <p><strong>140</strong>CheckedIn</p>
      </div>
      <div className='mx-3'><img src={Line} alt="" /></div>
    </div>
    <div className='inactiveemploy d-flex m-3'>
      <div><img src={inactive} alt="" /></div>
      <div className='mt-2 mx-2'>
        <h6>Today</h6>
        <p><strong>4</strong>Absent</p>
      </div>
      <div className='mx-3'><img src={Line} alt="" /></div>
    </div>
    <div className='pendingactivation d-flex m-3 '>
      <div><img src={pending} alt="" /></div>
      <div className='mt-2 mx-2'>
        <h6>Yesterday</h6>
        <p><strong>134</strong>CheckIn</p>
        </div>
        <div className='mx-2'><img src={line} alt="" /></div>
     
    </div>
    <div className='pendingactivation d-flex m-3 '>
      <div><img src={pending} alt="" /></div>
      <div className='mt-2 mx-2'>
        <h6>Yesterday</h6>
        <p><strong>10</strong>Absent</p>
        </div>
     
    </div>


  </div>

  <div className="container mt-3">
      <div className="row justify-content-between">
        <div className="col-md-5">
          <div className="input-group">
            
            <span className="input-group-text">
               <img src={searchIcon} alt="" />
              </span>
            <input
              type="text"
              className="search"
              placeholder="Search"
            />
          </div>
        </div>
   

       
       
      </div>
    </div>
        </div>
      )}

<div className="your-div your-div2">
            <div className='employ mt-5 d-flex justify-content-between'>
        <div className='d-flex '>
            <div className='emp'> Attendance</div>
           
       </div>

        <div className='d-flex ini '>
          <div className='mx-2'><img src={alarm} alt="" /></div>
          <div className='mx-2'><img src={line} alt="" /></div>
          <div><img src={initial} alt="" /></div>
        </div>
  </div>

  <div className='d-flex mx-3 mt-2 activities'>

    <div className='allemploy d-flex m-3'>
      <div><img src={all} alt="" /></div>
      <div className='mt-2 mx-2'>
        <h6>All employees</h6>
        <p><strong>144</strong></p>
      </div>
      <div className='mx-3'><img src={Line} alt="" /></div>
    </div>
    <div className='activeemploy d-flex m-3'>
      <div><img src={active} alt="" /></div>
      <div className='mt-2 mx-2'>
        <h6>Today</h6>
      <p><strong>140</strong> CheckedIn</p>
      </div>
      <div className='mx-3'><img src={Line} alt="" /></div>
    </div>
    <div className='inactiveemploy d-flex m-3'>
      <div><img src={inactive} alt="" /></div>
      <div className='mt-2 mx-2'>
        <h6>Today</h6>
        <p><strong>4</strong> Absent</p>
      </div>
      <div className='mx-3'><img src={Line} alt="" /></div>
    </div>
    <div className='pendingactivation d-flex m-3 '>
      <div><img src={pending} alt="" /></div>
      <div className='mt-2 mx-2'>
        <h6>Yesterday</h6>
        <p><strong>134</strong> CheckIn</p>
        </div>
        <div className='mx-2'><img src={line} alt="" /></div>
     
    </div>
    <div className='pendingactivation d-flex m-3 '>
      <div><img src={pending} alt="" /></div>
      <div className='mt-2 mx-2'>
        <h6>Yesterday</h6>
        <p><strong>10</strong> Absent</p>
        </div>
     
    </div>


  </div>




      <div className='employee-function-bar'>
        <div>
                  <CiSearch className='search-icon'/>
        <input placeholder='Search by date' className='input'/>
        </div>

        
        <div className="employee-button-div">
            <button className="outline-button filter-container">Export</button>
            <button className="filter-container">
              <select
                id="filterOption"
                value={filterOption}
                onChange={(e) => setFilterOption(e.target.value)}
              >
                <option value="">filter</option>
                <option value="yesterday" onClick={() => setTab('yesterday')}>Yesterday</option>
                <option value="twoDaysAgo">Two Days Ago</option>
                <option value="lastWeek">Last Week</option>
                <option value="lastMonth">Last Month</option>
              </select>
            </button>
            <button className="btn6" onClick={() => setTab('today')}>
              Today
            </button>
          </div>
        </div>

</div>



      {
        tab === 'Today' ? 
    <AttendanceTable/>
     : tab === 'today' ? <AttendanceTable/> : tab === 'yesterday' ? <Table/> : tab === 'two days ago' ? <div>two days ago</div> :tab === 'lastweek' ? <div>Last week</div> :tab === 'lastmonth' ? <div>last month</div> : <div className="center">
     <div className='small'>
       <div className='text '><img src={text} alt="" /></div>
       <div className='m-4 details'>
         <h6>There are no data entries yet</h6>
         <p>The attendance for the day will appear here</p>
       </div>
      
     </div>
</div>  
      }
      <div className='control-button'>
      <button className='prev-button'>
        <div className='prev-button-box'>
        <RiArrowLeftSLine className='prev-button-dark'/>
        <RiArrowLeftSLine className='prev-button-light'/>
        </div>
        <h1>previous</h1>
       </button>

       <button className='next-button'>
       
        <h1>Next</h1>
        <div className='next-button-box'>
        <RiArrowRightSLine className='next-button-light'/>
        <RiArrowRightSLine className='next-button-dark'/>
        </div>
       </button>
      </div>
      {
        showOption ?   <div className='position-absolute d-flex top-0 start-0 w-100 h-100 justify-content-center  align-items-center'>
        {
          option === 'option1' ? <div>
              <Employeeconnect setMode={setMode} setOption={setOption}/>
          </div> : mode && option === 'option2' ? <Sendinvite setOption={setOption} setShowOption={setShowOption}/> : option === 'option3' ? <div>
            {
              mode  ? <div><Invitesent setShowOption={setShowOption} setOption={setOption}/></div> : <div><Sendinvite setShowOption={setShowOption}/></div>
            }
          </div> : ''
        }
      </div> : ''
      }
    
  

   
  
       
       </>

  
  )
}

export default Attendance